import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import LangSelector from "./components/lang-selector";
import HandheldMenu from "./components/handheld-menu";
import ProductsMenu from "./components/menu-products";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import BackToTop from "./components/back-to-top";
import ProductCustomisation from "./components/product-customisation";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";
import HomeSlider from "./components/home-slider";
import IconsSlider from "./components/icons-slider";
import SliderHeader from "./components/header-slider";
import GalleryLightbox from "./components/gallery-lightbox";

import DeviceManager from "./utils/device-manager";

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		const langSelector = new LangSelector($(".language-selector"));

		// Home slider component
		const $homeSliders = $(".homepage-slider");
		if ($homeSliders.length) {
			$homeSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// Icons slider component
		const $iconsSliders = $(".icons-list-section__list");
		if ($iconsSliders.length) {
			$iconsSliders.each(function (index, el) {
				const iconsSlider = new IconsSlider($(el));
			});
		}

		// Slider header component
		const $headerSliders = $(".slider-header");
		if ($headerSliders.length) {
			$headerSliders.each(function (index, el) {
				const headerSlider = new SliderHeader($(el));
			});
		}

		const $productTabs = $('.single-product .product-top-tabs');
    	if ($productTabs.length) {
			import(/* webpackChunkName: "ProductTabsComponent" */ './components/product-tabs').then(module => {
				module.default();
			});
        }

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// SVG animation - Calculation automatique de la longueur des SVG
		const paths = document.querySelectorAll(".site-header__logo path");
		[].forEach.call(paths, function(path) {
			const length = path.getTotalLength();
			path.style.strokeDasharray = length + ' ' + length;
			path.style.strokeDashoffset = length;
		});

		// Détection du scroll pour le l'ancement d'animations
		if ($( 'body' )) {
			$(window).on('scroll', function (e) {
                if($('.list--coloured-bullet--primary').length > 0) {
                    if($(window).scrollTop() >= $('.list--coloured-bullet--primary').offset().top - 750){
                        $('.list--coloured-bullet--primary li').addClass('active');
                    }
                }
				if($('.text-image-section__content.background--image_disabled').length > 0) {
                    if($(window).scrollTop() >= $('.list--coloured-bullet--primary').offset().top - 1000){
                        $('.text-image-section__svg').addClass('active');
						$('.text-image-section__picture').addClass('active');
                    }
                }
				if($('.icons-list-section__list').length > 0) {
                    if($(window).scrollTop() >= $('.icons-list-section__list').offset().top - 1000){
                        $('.icons-list-section__item-image').addClass('active');
                    }
                }
			});
		}

	}

	bootstrapApp();
	instanciateComponents();


	/**
	 * Synchro des boutons radios avec les selects pour
	 * le choix des déclinaisons
	 */
	$('form.variations_form').on('change', 'input[type=radio][name=product_merged_variations]', function() {
		var val = $(this).val();
		var target = $(this).data('target');
		var colorsSelect = $('select#pa_materiau-et-coloris');
		var capacitySelect = $('select#pa_capacite');

		if(val.indexOf('|') !== -1) {
			var valueParts = val.split('|');
			colorsSelect.val(valueParts[0]);
			capacitySelect.val(valueParts[1]).trigger('change');
		}
	});

	// Au chargement on lance des triggers pour initialiser le système
	$('form.variations_form input[type=radio]:checked').trigger('change');

	/**
	 * Affichage des temps de livraisons
	 */
	$('form.variations_form').on('show_variation', function(event, variation) {
		$('.single-product .entry-summary .price').replaceWith(variation.price_html);
		$('.woocommerce-delivery-time').html(variation.delivery_time);
	});
});